import { Navigate, Outlet } from 'react-router-dom'
import { authService } from '@services/authService'

interface ProtectedRouteProps {
  requireAdmin?: boolean
  requireAuth?: boolean
  requireMerchant?: boolean
  allowedRoles?: ('admin' | 'merchant' | 'user')[]
  redirectTo?: string
}

export default function ProtectedRoute({
  requireAdmin = false,
  requireAuth = true,
  requireMerchant = false,
  allowedRoles = [],
  redirectTo = '/login'
}: ProtectedRouteProps) {
  const isAuthenticated = authService.isAuthenticated()
  const isAdmin = authService.isAdmin()
  const isMerchant = authService.isMerchant()
  const user = authService.getCurrentUser()

  if (requireAuth && !isAuthenticated) {
    return <Navigate to={redirectTo} replace />
  }

  // Check role-based access
  if (allowedRoles.length > 0 && user && !allowedRoles.includes(user.role)) {
    // User doesn't have required role, redirect based on their role
    if (isAdmin) {
      return <Navigate to="/dashboard" replace />
    } else if (isMerchant) {
      return <Navigate to="/dashboard" replace />
    } else {
      return <Navigate to="/dashboard" replace />
    }
  }

  // Legacy support for requireAdmin
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />
  }

  // Legacy support for requireMerchant
  if (requireMerchant && !isMerchant) {
    return <Navigate to="/dashboard" replace />
  }

  return <Outlet />
}
